import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { createApiCallEffects } from 'src/app/common/store/generic.effects';
import { UserAction, userActions } from './user.actions';
import { UserApiService } from './user.api.services';
import { IUserState } from './user.reducer';

@Injectable()
export class UserEffects {
  constructor(
    private readonly store: Store<IUserState>,
    private readonly userApiService: UserApiService,
    private readonly action$: Actions<UserAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    userActions.getById,
    this.userApiService.getById,
  );

  getMainSalesTeamById = createApiCallEffects(
    this,
    this.action$,
    userActions.getMainSalesTeamById,
    this.userApiService.getMainSalesTeamById,
  );

  add = createApiCallEffects(
    this,
    this.action$,
    userActions.add,
    this.userApiService.add,
  );

  update = createApiCallEffects(
    this,
    this.action$,
    userActions.update,
    this.userApiService.update,
  );

  lockout = createApiCallEffects(
    this,
    this.action$,
    userActions.lockout,
    this.userApiService.lockout,
  );

  getCurrentUser = createApiCallEffects(
    this,
    this.action$,
    userActions.getCurrentUser,
    this.userApiService.getCurrentUser,
  );

  getConnectionHistoriesById = createApiCallEffects(
    this,
    this.action$,
    userActions.getConnectionHistoriesById,
    this.userApiService.getConnectionHistoriesById,
  );

  getStatusActions = createApiCallEffects(
    this,
    this.action$,
    userActions.getStatusActions,
    this.userApiService.getStatusActions,
  );
}
